import { Component, EventEmitter, Input, OnInit, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Page } from "app/dto/page.dto";
import { DynamicFormComponent } from "app/genericForm/components/dynamic-form/dynamic-form.directive";
import { BotonTabla } from "app/genericForm/components/table/interface/boton-tabla.interface";
import { ButtonsRowConfig } from "app/genericForm/components/table/interface/buttons-row.interface";
import { TableHeaderConfig } from "app/genericForm/components/table/interface/table-header.interface";
import { FieldConfig } from "app/genericForm/field.interface";
import { AlertaUsuarioService } from "app/service/alerta-usuario.service";
import { CargandoService } from "app/shared/cargando/cargando.service";

@Component({
  selector: 'app-notificaciones',
  templateUrl: './modal-notificaciones.component.html',
  styleUrls: ['./modal-notificaciones.component.scss'],
})
export class ModalNotificacionesComponent implements OnInit {
  @ViewChild(DynamicFormComponent) form: DynamicFormComponent;
  formFiltro: FieldConfig[];
  page = 0;
  size = 50;
  paginadoEvent: EventEmitter<Page> = new EventEmitter<Page>();
  headerConfig: TableHeaderConfig[];
  buttonsRowConfig: ButtonsRowConfig;
  @Input() public modalRef: NgbModalRef;
  listLeidos = [{ id: null, display: "TODAS" }, { id: true, display: "LEIDAS" }, { id: false, display: "NO LEIDAS" }]
  botonesCustom: BotonTabla[];

  constructor(
    private alertaUsuarioService: AlertaUsuarioService,
    private router: Router,
    private cargandoService: CargandoService) {
    this.buttonsRowConfig = {
      deleteActive: false,
      editActive: false,
      verActive: false,
      verUrl: "",
      editUrl: "",
      fieldIdName: ""
    };

    this.botonesCustom = [
      {
        visible: (noti: any) => { return noti.alerta.link !== null && noti.alerta.link !== '' },
        clasesBoton: "mat-raised-button bg-basic boton-custom",
        tieneIcono: false,
        icono: null,
        clasesIcono: null,
        etiqueta: "Ir a enlace",
        clasesEtiqueta: null,
        click: (noti: any) => {
          this.router.navigate([noti.alerta.link]);
          window.location.reload();
        }
      }
    ];

    this.headerConfig = [
      {
        columnOrder: 1,
        objectKey: 'alerta.titulo',
        title: "Alerta"
      },
      {
        columnOrder: 2,
        objectKey: 'alerta.mensaje',
        title: "Mensaje",
        center: true
      },
    ]
  }

  ngOnInit() {
    this.formFiltro = [
      {
        type: "input",
        label: "Mensaje",
        inputType: "text",
        name: "mensaje",
        claseGrillaBootstrap: "col-6",
      },
      {
        type: "select",
        label: "Leído",
        name: "leido",
        description: "display",
        id: "id",
        claseGrillaBootstrap: "col-6",
        options: this.listLeidos,
        value: { id: null, display: "TODAS" }
      }, {
        type: "date",
        label: "Fecha Pospuesta",
        inputType: "text",
        name: "fechaPospuesta",
        claseGrillaBootstrap: "col-6"
      },
      {
        name: "btnLimpiar",
        type: "button",
        label: "Limpiar",
        limpiar: true
      },
      {
        disabled: false,
        name: "btnBuscar",
        type: "submit",
        label: "Buscar"
      },
      {
        type: "spinner",
        id: "buscador",
        claseGrillaBootstrap: "col-2"
      }
    ];
  }

  async buscar(formulario: any) {
    await this.findAlertaUsuario(formulario.leido?.id, formulario.fechaPospuesta, formulario.mensaje).then();
  }

  async onChangePage(page: number) {
    this.page = page;
    await this.findAlertaUsuario(this.form.form.get("leido").value?.id, this.form.form.get("fechaPospuesta").value, this.form.form.get("mensaje").value);
  }

  async onChangeSize(size: number) {
    this.page = 0;
    this.size = size;
    await this.findAlertaUsuario(this.form.form.get("leido").value?.id, this.form.form.get("fechaPospuesta").value, this.form.form.get("mensaje").value);
  }

  async findAlertaUsuario(leido: boolean, fechaPospuesta: Date, mensaje: string) {
    this.cargandoService.start("buscador");
    await this.alertaUsuarioService.paginado(this.page, this.size, leido, fechaPospuesta, mensaje)
      .toPromise()
      .then(d => {
        this.paginadoEvent.emit(d);
        this.form.changeStateSubmit(false);
        this.cargandoService.stop("buscador");
      });
  }

  cerrar() {
    this.modalRef.close();
  }
}
